import React from 'react';
import {
    useTheme,
    View,
    Heading,
    type AuthenticatorProps,
} from '@aws-amplify/ui-react';

type Config = Required<AuthenticatorProps>['components'];

export const AuthenticatorComponent: Config = {
    Header() {
        const { tokens } = useTheme();
        return <View padding={tokens.space.xxl} />;
    },
    SignIn: {
        Header() {
            const { tokens } = useTheme();
            return (
                <Heading
                    fontSize={tokens.fontSizes.large}
                    marginTop={tokens.space.xl}
                    marginLeft={tokens.space.xl}
                >
                    Waymark Portal ログイン
                </Heading>
            );
        },
    },
    ConfirmSignIn: {
        Header() {
            return <Heading>認証コード入力</Heading>;
        },
    },
    ForceNewPassword: {
        Header() {
            return <Heading>パスワード再交付</Heading>;
        },
    },
    ForgotPassword: {
        Header() {
            return <Heading>パスワード再交付</Heading>;
        },
    },
    ConfirmResetPassword: {
        Header() {
            return <Heading>パスワード再交付</Heading>;
        },
    },
};
